import { render } from "./DeviceGroups.vue?vue&type=template&id=6363a656"
import script from "./DeviceGroups.vue?vue&type=script&lang=js"
export * from "./DeviceGroups.vue?vue&type=script&lang=js"

import "./DeviceGroups.vue?vue&type=style&index=0&id=6363a656&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__